import { Skeleton, SkeletonProps } from '@chakra-ui/react'
import React from 'react'

const AppSkeleton = ({ height, width, borderRadius, borderWidth, color }:SkeletonProps) => {
  return (
    <Skeleton height={height} width={width} borderRadius={borderRadius} borderWidth={borderWidth} bgColor={color} />
  )
}

export default AppSkeleton
